module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_tingsryd-80c259f515f95cb334bf9cb92c1ac419.png";